module.exports = __webpack_public_path__ + "static/img/icon_measure.c8f276c5.svg";